<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigation.vue is part of event_pass_client.dev.            -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigation.vue can not be copied and/or distributed                   -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 16:43-->

<template>
    <nav id="main-nav"
         data-element="main-nav"
         class="main-nav navbar fixed-top navbar-toggleable-md scrolling-navbar pb-0 px-0"
         :class="readSite"
    >
        <div  v-if="readSite === 'splendourparking'">
            <div class="main-nav-bg-image-container" style="background-color: #12203e; z-index: -10; left:0px;">&nbsp;
            </div>
        </div>
        <div v-else>
            <div class="main-nav-bg-image-container">
                <img :src="readLogo"
                     :alt="app_name"
                     class="main-nav--bg-image"
                >
            </div>
        </div>

        <div class="main-nav--user-actions w-md-100">
            <section class="d-flex justify-content-center w-80 w-md-90 align-items-center">
                <!--hamburger-->
                <main-navigation-hamburger @controller="readSideNav"
                                           :side_nav="side_nav"
                                           class="cursor-pointer"
                />
                <div class="main-nav--logo">
                    <div  v-if="readSite==='brentfordfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/brentford_logo_orig.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Gtech Community Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div v-else-if="readSite ==='swanseaparking'">
                        <div id="css-logo">
                    
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/swanseaparking-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Swansea.com Stadium</div>
                            </div>
                    
                        </div>
                    </div>
                    <div v-else-if="readSite ==='busbus'">
                        <div id="css-logo">
                    
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/busbus-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">Coach Tickets</div>
                                <div class="subheading">Coach tickets to various venues</div>
                            </div>
                    
                        </div>
                    </div>
                    <div v-else-if="readSite === 'ricoharenaparking'">
                        <div id="css-logo">
                
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/coventry-city-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Coventry City Football Club</div>
                            </div>
                
                        </div>
                    </div>
                    <div v-else-if="readSite === 'arcticmonkeysparking'">
                        <div id="css-logo">
            
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/arcticmonkeysparking-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">Parking</div>
                                <div class="subheading">Arctic Monkeys Tour 2023</div>
                            </div>
            
                        </div>
                    </div>
                    <div v-else-if="readSite === 'astonvillaparking'">
                        <div id="css-logo">
                
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/astonvillaparking-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Villa Park</div>
                            </div>
                
                        </div>
                    </div>
                        <div v-else-if="readSite === 'splendourparking'">
                            <div id="css-logo1">
                
                                <img data-v-cb327de0=""
                                    src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/splendourparking-web-logo-200.png"
                                    alt="Logo">
                                <div class="text">
                                    <div class="heading" style="text-align: center; font-size:130%; color: #ecd5ad;">Official Parking</div>
                                </div>
                
                            </div>
                        </div>
                            <div v-else-if="readSite === 'liverpoolfcparking'">
                            <div id="css-logo">
                
                                <img data-v-cb327de0=""
                                    src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/liverpoolfcparking-web-logo-200.png"
                                    alt="Logo">
                                <div class="text">
                                    <div class="heading">Official Parking</div>
                                    <div class="subheading">Liverpool Football Club</div>
                                </div>
                
                            </div>
                        </div>
                        <div  v-else-if="readSite==='londonirishparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/londonirishparking_logo_200x200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Gtech Community Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='hawthornsparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/hawthornsparking_logo_200x200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Parking</div>
                                <div class="subheading">The Hawthorns Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='watfordfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/watfordfcparking_logo_200x200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Watford Football Club</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='wolvesparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/wolvesparking_logo_200x200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Parking</div>
                                <div class="subheading">Match Day Parking</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='gloucesterrugbyparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/gloucesterrugbyparking_logo_200x200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Gloucester Rugby</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='dcfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/dcfcparking-web-logo.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Parking</div>
                                <div class="subheading">Derby County Football Club</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='portvaleparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/portvaleparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Vale Park Football Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='barnsleyfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/barnsleyfcparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Oakwell Football Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='burnleyfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/burnleyfcparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Turf Moor Football Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='stokecityfcparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/stokecityfcparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">bet365 Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='ajbellstadiumparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/ajbellstadiumparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Salford Stadium</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite==='nottsforestparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/nottsforestparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">The City Ground</div>
                            </div>

                        </div>
                    </div>
                    <div  v-else-if="readSite === 'coronasunsetsparking'">
                        <div id="css-logo">

                            <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/coronasunsetsparking-web-logo-200.png" alt="Logo">
                            <div class="text">
                                <div class="heading">Official Parking</div>
                                <div class="subheading">Various Parking Venues</div>
                            </div>

                        </div>
                    </div>
                        <div  v-else-if="readSite === 'worcestershowtickets'">
                            <div id="css-logo">

                                <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/worcester_city.png" alt="Worcester City Logo">
                                <img data-v-cb327de0="" src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/worcestershowtickets-web-logo-200.png" alt="Logo">
                                <div class="text">
                                    <div class="heading">Official Tickets</div>
                                    <div class="subheading">The Worcester Show</div>
                                </div>

                            </div>
                        </div>
                        <div v-else-if="readSite ==='thebigparking'">
                        <div id="css-logo">
                    
                            <img data-v-cb327de0=""
                                src="https://est-event-pass-assets.s3-eu-west-1.amazonaws.com/images/logos/venues/thebigparking-web-logo-200.png"
                                alt="Logo">
                            <div class="text">
                                <div class="heading">The Big Parking</div>
                                <div class="subheading">Various Parking Venues</div>
                            </div>
                    
                        </div>
                    </div>
                    <div v-else>
                        <a href="/">
                            <img :src="readLogo"
                                :alt="app_name"
                                class="img-fluid w-100"
                                style="max-height:50px"
                            >
                        </a>
                    </div>
                </div>
                <!--search block-->
                <div  v-if="readSite === 'splendourparking'">
                    <section class="d-flex justify-content-center align-items-center bd-highlight" style="color: #f5a008;">
                        <main-navigation-search-top :search="search"/>
                    </section>
                </div>
                <div v-else>
                    <section class="d-flex justify-content-center align-items-center bd-highlight">
                        <main-navigation-search-top :search="search"/>
                    </section>
                </div>


                <div  v-if="readSite === 'splendourparking'" style="color: #f5a008;">
                    <!--guest login-->
                    <main-navigation-auth v-if="user.id !== null"
                                          :route="route"
                                          :user="user"
                                          class="d-none d-md-block"
                    />
                    <!--auth user-->
                    <main-navigation-public v-else
                                            :route="route"
                                            class="d-none d-md-block"
                    />
                </div>
                <div v-else>
                    <!--guest login-->
                    <main-navigation-auth v-if="user.id !== null"
                                          :route="route"
                                          :user="user"
                                          class="d-none d-md-block"
                    />
                    <!--auth user-->
                    <main-navigation-public v-else
                                            :route="route"
                                            class="d-none d-md-block"
                    />
                </div>
            </section>
        </div>

        <section class="main-nav--page-actions w-100">
            <main-navigation-custom-page-links :pages="pages"/>
        </section>
        <div v-if="route_name !== checkout_page" id="basket--trigger"
             class="bd-highlight"
        >
            <div id="modal_basket--wrapper">
                <modal_basket @readBasket="readBasket()"
                              :content="basket_compiled"
                              :timer_length_in_minutes="timer_length_in_minutes"
                />
            </div>
        </div>
    </nav>
</template>

<script>
    import localforage from 'localforage';
    import addDays from 'date-fns/add_days';
    import compareDesc from 'date-fns/compare_desc'
    import VueLocalForage from 'vue-localforage';

    import {_} from 'underscore';

    window.modalBasketVue = window.Vue.component('modal_basket', require('../modals/Basket'));

    window.Vue.use(VueLocalForage);
    /**
     * Global search bar
     */
    window.Vue.component('main-navigation-search-top', require('./MainNavigationSearchTop'));

    /**
     * Logged in user links
     */
    window.Vue.component('main-navigation-auth', require('./MainNavigationAuth'));
    /**
     * Guest user links e.g. log in here ...
     */
    window.Vue.component('main-navigation-public', require('./MainNavigationPublic'));

    /**
     * Hamburger trigger side navigation
     */
    window.Vue.component('main-navigation-hamburger', require('./MainNavigationHamburger'));

    /**
     * Custom page links defined for each venue e.g events, rugby events, music events, etc...
     */
    window.Vue.component('main-navigation-custom-page-links', require('./MainNavigationCustomPageLinks'));
    export default {
        name: "main-navigation",
        components: {},
        props: {
            timer_length_in_minutes:{
                type:Number,
                default:15
            },
            route_name: {
                type: String
            },
            route: {
                type: Object
            },
            navigation_pages: {
                type: Object,
                default: null
            },
            user: {
                type: Object
            },
            search: {
                type: Object
            },
            basket: {
                type: Object
            },
            app_name: {
                type: String
            },
        },
        created() {
            this.$eventHubMainNav.$on('side_nav_close', this.readSideNav);
        },
        destroyed() {
        },
        mounted() {
            let self = this;
            self.basket_compiled = self.basket;
            self.pages.url = self.route.pages.url;

            if (self.navigation_pages !== null) {
                self.pages.main = self.navigation_pages.main;
                self.pushLinksToSideNav();
            } else {
                self.loadNavCache();
            }
            self.$eventHubMainNav.$on('side_nav_close', this.readSideNav);
        },
        data() {
            return {
                checkout_page:'basket:index',
                asset_expiry: 1,
                basket_compiled: {},
                side_nav: {},
                current_asset: {},
                pages: {
                    namespace: 'main_nav',
                    key: 'main_nav_links',
                    items: {},
                    url: '',
                    main: Array
                }
            }
        },
        methods: {
            loadNavCache() {
                let self = this,
                    jsScriptElement = document.getElementById('app_js');

                let jsElementSrc = jsScriptElement.getAttribute('src');

                self.current_asset = self.getParams(jsElementSrc);

                // console.log('createPageLinks', 'current_asset', self.current_asset);
                //get the current asset record
                self.$getItem('asset_manifest')
                    .then(function (manifest) {
                        // console.log('asset_manifest', 'manifest',manifest,'self.current_asset',self.current_asset);
                        // no manifest so request new stuff

                        if (manifest == null) {
                            // update required
                            self.readPageLinks(true);
                        } else {

                            /**
                             * compareDesc(manifest.expires, new Date())
                             * return -1 if the first date is after the second
                             */
                            let compareDate = compareDesc(manifest.expires, new Date());

                            if (manifest.id !== self.current_asset.id || compareDate >= 0) {
                                // console.log('', 'update required');
                                // update required
                                self.readPageLinks(true);
                            } else {
                                //no update required
                                self.readPageLinks(false);
                            }
                        }
                    });
            },
            readPageLinks(update_required) {
                let self = this,
                    _update_required = update_required;

                // get item from local storage
                this.$getItem(self.pages.key)
                    .then(function (pages) {
                        // request via axios if it is not there
                        if (pages === null || _update_required) {
                            self.requestPageLinks();
                            // console.warn('no data','pages',pages);
                        } else {
                            self.pages.main = pages;
                            self.pushLinksToSideNav();
                            // console.log('readPageLinks', 'pushLinksToSideNav');
                        }
                        // This code runs once the value has been loaded
                        // from the offline store.
                        // console.log(value);
                    }).catch(function (err) {
                    // This code runs if there were any errors
                    console.error(err);
                });
            },
            createPageLinks(data) {
                let self = this;

                this.pages.main = _.sortBy(data.main, function (page) {
                    return page.lft;
                });

                // set localstorage
                self.$setItem(self.pages.key, this.pages.main, function (test) {
                    // console.log('createPageLinks', test, self.pages.key);
                });

                let expiryDate = addDays(new Date(), 1);
                self.$setItem('asset_manifest', {
                    id: self.current_asset.id,
                    expires: expiryDate
                }, function (test) {
                    // console.log('$setItem', 'test', test);
                });
                this.pushLinksToSideNav();
            },
            getParams(src) {
                let [uri, params] = src.split`?`;
                // console.log('getParams', 'k',k,'v',v);
                // gets url parameters and builds an object
                return _.chain(params.split('&'))
                    .map(function (item) {
                        if (item) {
                            return item.split('=');
                        }
                    })
                    .compact()
                    .object()
                    .value();
            },

            requestPageLinks() {
                // console.log('requestPageLinks', 'requesting');
                let self = this;

                let data = {};

                axios.post(this.pages.url, data)
                    .then(function (response) {
                        if (response.data.success) {
                            console.log('response.data', 'response.data', response.data);
                            self.createPageLinks(response.data.pages);
                        }
                    })
                    .catch(function (e) {
                        console.error('error', e);
                    });
            },
            pushLinksToSideNav() {
                // push to side nav so it also has the updated pages list
                this.$eventHubMainNav.$emit('side_nav_pages', this.pages);
            },

            readSideNav(data) {
                this.side_nav = data;
                this.$eventHubMainNav.$emit('side_nav', this.side_nav);
                this.$eventHubMainNav.$emit('side_nav_pages', this.pages);
            },
        },
        computed: {
            readLogo() {
                return process.env.MIX_MY_LOGO;
            },
            readSite() {
                return process.env.MIX_CLIENT_SUB_DOMAIN;
            },
        },
        watch: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigation.vue